import React from 'react';

function SectionCard({ 
  title, 
  description, 
  sectionIndex, 
  children, 
  variant = 'default' 
}) {
  const opacityClass = variant === 'readonly' ? 'opacity-60' : '';
  
  return (
    <div className={`space-y-2 sm:space-y-3 ${opacityClass}`} data-testid={`template-section-${sectionIndex}`}>
      <div className="flex items-start gap-2.5 sm:gap-3.5 px-1">
        <div className="h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
          <span className="text-xs sm:text-sm font-semibold text-primary">{sectionIndex + 1}</span>
        </div>
        <div className="flex-1">
          <h3 className="text-base sm:text-lg font-semibold text-foreground leading-tight">{title}</h3>
          {description && (
            <p className="text-xs sm:text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </div>
      </div>
      <div className="mt-2 sm:mt-3 bg-card rounded-lg border border-border/50 overflow-hidden">
        <div className="divide-y divide-border/50 px-4 sm:px-6">
          {children}
        </div>
      </div>
    </div>
  );
}

export default SectionCard;
